"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var withStyles_1 = require("../decorators/withStyles");

var HiddenResponsive_1 = __importDefault(require("../HiddenResponsive/HiddenResponsive"));

function isXValues(props) {
  return props.hasOwnProperty('mobileX') || props.hasOwnProperty('desktopX');
}

var emptyStyles = function emptyStyles(_theme) {
  return {};
};

var Margin = function Margin(props) {
  var heightDesktop;
  var heightMobile;

  if (isXValues(props)) {
    var mobileX = props.mobileX,
        desktopX = props.desktopX,
        theme = props.theme;
    heightDesktop = desktopX * theme.x1;
    heightMobile = mobileX * theme.x1;
  } else {
    var desktop = props.desktop,
        mobile = props.mobile;
    heightDesktop = desktop;
    heightMobile = mobile;
  }

  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(HiddenResponsive_1.default, {
    type: "desktop"
  }, react_1.default.createElement("div", {
    "data-test-id": "margin-mobile",
    style: {
      height: heightMobile
    }
  })), react_1.default.createElement(HiddenResponsive_1.default, {
    type: "mobile"
  }, react_1.default.createElement("div", {
    "data-test-id": "margin-desktop",
    style: {
      height: heightDesktop
    }
  })));
};

exports.default = withStyles_1.withStyles(emptyStyles)(Margin);